import { render, staticRenderFns } from "./onHpbz.vue?vue&type=template&id=6ec95b20&scoped=true"
import script from "./onHpbz.vue?vue&type=script&lang=js"
export * from "./onHpbz.vue?vue&type=script&lang=js"
import style0 from "./onHpbz.vue?vue&type=style&index=0&id=6ec95b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec95b20",
  null
  
)

export default component.exports